import { calcSubPath } from '../util/sub_path';
const rootPath = process.env.NODE_ENV === 'production' ? calcSubPath() : 'http://localhost/';
const baseUrl = `${rootPath}api/v1`;

export default {
  getDocumentByVersion({ type, device }, version, path) {
    const params = [`type=${type}`, `device=${device}`];
    if (path) {
      params.push(`path=${encodeURIComponent(path)}`);
    }
    return fetch(`${baseUrl}/document/${version}?${params.join('&')}`);
  },
  getMenusFullPathByVersion({ type, device }, version) {
    const params = [`type=${type}`, `device=${device}`];
    return fetch(`${baseUrl}/menusFullPath/${version}?${params.join('&')}`);
  },
  getVersions({ type, device }) {
    return fetch(`${baseUrl}/versions?type=${type}&device=${device}`);
  }
};
